var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import getAllClosedServiceEntries from "../../requests/service/getAllClosedServiceEntries";
import Command from "../Command";
var GetAllClosedServiceEntriesCommand = /** @class */ (function (_super) {
    __extends(GetAllClosedServiceEntriesCommand, _super);
    function GetAllClosedServiceEntriesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param organisation OrganisationModel
     */
    GetAllClosedServiceEntriesCommand.prototype.execute = function (organisation) {
        var promise = getAllClosedServiceEntries(organisation);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    GetAllClosedServiceEntriesCommand.prototype.then = function (response) {
    };
    return GetAllClosedServiceEntriesCommand;
}(Command));
export default GetAllClosedServiceEntriesCommand;
